import { handleRole } from '../../hooks/useAuthUtil'
import { ROLE_SET, ROLE_BUYER } from './constants'

const initialState = handleRole()

export default (state = initialState, action) => {
  switch (action.type) {
    case ROLE_SET:
      return action.role
    default:
      return state
  }
}
